import { Controller } from "@hotwired/stimulus"

// Opens a toggletip's popover on mouse hover as well as on click (every
// toggletip from ToggletipHelper). Only mouse pointers count, so a tap on a
// touch screen toggles it once instead of opening on the synthetic hover and
// closing on the click. Escape and outside clicks still close it, because it is
// a popover="auto". The listener sits on the wrapper, which contains the
// popover, so moving onto the popover keeps it open; the short delay bridges
// the gap between the trigger and the popover.
export default class extends Controller {
  static targets = ["popover"]

  declare readonly popoverTarget: HTMLElement

  private hideTimer?: number

  show(event: PointerEvent): void {
    if (event.pointerType !== "mouse") return

    window.clearTimeout(this.hideTimer)
    if (!this.popoverTarget.matches(":popover-open")) this.popoverTarget.showPopover()
  }

  hide(event: PointerEvent): void {
    if (event.pointerType !== "mouse") return

    this.hideTimer = window.setTimeout(() => {
      if (this.popoverTarget.matches(":popover-open")) this.popoverTarget.hidePopover()
    }, 150)
  }

  disconnect(): void {
    window.clearTimeout(this.hideTimer)
  }
}
